import getWindow from './getWindow';
import safeLocalStorage from './safeLocalStorage';

export { getWindow, safeLocalStorage };
